import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.VUE_APP_API_SENTRY_DNS || process.env.VUE_APP_API_SENTRY_DNS !== 'null') {
  // noinspection JSCheckFunctionSignatures # Vue has no Instance
  Sentry.init({
    environment: process.env.VUE_APP_API_SENTRY_ENVIRONMENT,
    dsn: process.env.VUE_APP_API_SENTRY_DNS,
    ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
    integrations: [
      new Integrations.Vue({
        Vue: Vue,
        attachProps: true,
        logErrors: true,
        tracing: true,
      }),
    ],
    tracesSampleRate: parseFloat(process.env.VUE_APP_API_SENTRY_TRACES_SAMPLE_RATE),
  });
}
